<script>
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import { UserMessageElementMixin } from "%/dynamic-component-editor/standard-components/user-message/user-message-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "UserMessageCreated",
  elementPanelSettings: {
    displayIcon: "text-alt",
    elementGroup: "User Messages",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [UserMessageElementMixin, DateElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.formattedDate(this.entity.timestampContentUpdated);
    },
  },
};
</script>
